import React from "react";

function Terms(){
    return(
        <div>
            <div className="pageBanner lifeAtELite_banner">
                <div className="bannerCover d-flex  flex-column justify-content-center align-items-center text-center">
                    <h2 className='main_heading titleFont_style text-light pt-4'>Terms & Conditions</h2>
                </div>
            </div>
            
            <section class="section_padding bg-light">
                <div class="container">
                    <h4>OVERVIEW</h4>
                    
                    <p>
                        Welcome to <b>Elite Techlogix</b>
                    </p>

                    <p>
                        By accessing or using our website <b>elitetechlogix.com</b> or any of our services,
                        you agree to be bound by these <b>Terms and Conditions</b>, as well as our <b>Privacy Policy</b>.
                        If you do not agree with any part of these terms, please refrain from using our website or services.
                    </p>

                    <p>
                        <b>Elite Techlogix</b> reserves the right to modify or update these Terms and Conditions
                        at any time without prior notice. The most recent version will always be available 
                        on this page, and continued use of our services constitutes acceptance of any changes.
                    </p>

                    <h5>SECTION 1 - NATURE OF SERVICES</h5>

                    <p>
                        Elite Techlogix is a <b>business-to-business (B2B) service provider</b> specializing in <b>
                        lead generation, digital marketing, and call center solutions </b>. Our goal is to 
                        provide verified, qualified leads and customized marketing services that align with 
                        our clients’ business objectives.
                    </p>

                    <p>
                        All services are provided on a <b>best-effort basis</b> and are subject to availability,
                        data accuracy, and client cooperation.
                    </p>

                    <h5>SECTION 2 - USE OF THE WEBSITE</h5>

                    <p>
                        You agree to use this website solely for lawful purposes and in a manner that does 
                        not infringe the rights of, restrict, or inhibit anyone else’s use of the website.
                        You must not attempt to gain unauthorized access to any portion of the site, server, or any connected systems.
                    </p>

                    <p>
                        Elite Techlogix reserves the right to restrict or terminate access if misuse or unlawful activity is detected.
                    </p>

                    <h5>SECTION 3 - SERVICE ENGAGEMENT</h5>

                    <p>
                        All service engagements with Elite Techlogix are governed by a formal proposal, 
                        quotation, or agreement shared with the client prior to the start of work.
                    </p>

                    <p>
                        By confirming a service request, the client acknowledges acceptance of the proposed scope, 
                        pricing, and timelines.
                    </p>

                    <p>
                        Elite Techlogix shall not be held liable for delays or performance issues arising due 
                        to incomplete information, lack of client response, or factors beyond our reasonable control.
                    </p>

                    <h5>SECTION 4 - PAYMENTS AND BILLING</h5>

                    <p>
                        Payments for services must be made as per the agreed terms mentioned in the 
                        invoice or service agreement. Elite Techlogix uses secure and authorized e-payment 
                        gateways for online transactions. All payments must be made in the agreed currency and 
                        within the specified time period.
                    </p>

                    <p>
                        Elite Techlogix reserves the right to suspend or discontinue services in case of delayed 
                        or incomplete payments.
                    </p>

                    <h5>SECTION 5 - REFUNDS AND REVISIONS (if applicable)</h5>

                    <p>
                        As a <b>service-based company</b>, Elite Techlogix does not offer monetary refunds once a service 
                        has commenced or been delivered. However, in the event of a genuine concern regarding 
                        service quality, clients are encouraged to report the issue within <b>48 hours</b> of delivery.
                    </p>

                    <p>
                        Our <b>Quality Assurance Department</b> will review the concern, and where applicable,
                        a service adjustment or revision may be offered at our discretion. For more information, 
                        please see our REFUND POLICY.
                    </p>

                    <h5>SECTION 6 – CONFIDENTIALITY AND INTELLECTUAL PROPERTY</h5>

                    <p>
                        Elite Techlogix respects the confidentiality of all information shared by clients.
                        Any data, business details, or strategies received during service engagement will be 
                        kept strictly confidential and will not be disclosed to any third party without written 
                        consent, except where required by law.
                    </p>

                    <p>
                        Elite Techlogix follows strict data protection and privacy standards in line with applicable 
                        laws and banking regulations. For detailed information on how we collect, use, and 
                        protect your personal data, please review our PRIVACY POLICY.
                    </p>

                    <p>
                        All content, materials, designs, and data created or provided by Elite Techlogix remain the 
                        intellectual property of Elite Techlogix unless otherwise stated in writing.
                        Clients may use deliverables solely for their internal business purposes and may not 
                        reproduce, resell, or redistribute them without prior authorization.
                    </p>

                    <h5>SECTION 7 - LIMITATION OF LIABILITY</h5>

                    <p>
                        Elite Techlogix shall not be held liable for any direct, indirect, incidental, or 
                        consequential damages arising from the use or inability to use our services or website.
                        While every effort is made to provide accurate and reliable data, we do not 
                        guarantee the absolute accuracy or results of the leads or marketing outcomes.
                    </p>

                    <h5>SECTION 8 - THIRD-PARTY LINKS AND TOOLS</h5>

                    <p>
                        Our website may include links to third-party websites or tools for convenience and reference.
                        Elite Techlogix is not responsible for the content, security, or privacy practices 
                        of those third-party sites and encourages users to review their respective policies before engagement.
                    </p>

                    <h5>SECTION 9 - PERSONAL INFORMATION</h5>

                    <p>
                        Your submission of personal information through the website is governed by our Privacy 
                        Policy. To view our Privacy Policy, please see <a href="/privacy">here.</a>
                    </p>

                    <h5>SECTION 10 - GOVERNING LAW</h5>

                    <p>
                        These Terms of Service and any separate agreements whereby we provide you Services 
                        shall be governed by and construed in accordance with the laws of Pakistan.
                    </p>

                    <h5>SECTION 11 - CHANGES TO TERMS OF SERVICE</h5>

                    <p>
                        You can review the most current version of the Terms of Service at any time at this page.
                    </p>

                    <p>
                        We reserve the right, at our sole discretion, to update, change or replace any part 
                        of these Terms of Service by posting updates and changes to our website. 
                        It is your responsibility to check our website periodically for changes. 
                        Your continued use of or access to our website or the Service following 
                        the posting of any changes to these Terms of Service constitutes acceptance of those changes.
                    </p>

                    <h5>SECTION 12 - CONTACT INFORMATION</h5>

                    <p>
                        Questions about the Terms of Service should be sent to us at info@elitetechlogix.com
                    </p>

                    <p>
                        Our contact information is posted below:
                    </p>

                    Elite Techlogix <br />
                    info@elitetechlogix.com <br />
                    19 H2 - Abdul Haque Rd. Phase 2, Johar Town, Lahore, Pakistan <br />
                    +92-42-35833800
                </div>
            </section>
        </div>
    )
}

export default Terms;